import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { followLoginReturnUrl, sanitizeReturnTo } from '../lib/loginReturnUrl';
import { removeStoredQueryParams } from '../utils/queryParamStore';

/**
 * Opens the login/signup modal when Academy is reached with `?auth=login|signup`
 * and an optional `return_to` (e.g. from Studio Sign in / Sign up links).
 */
export function LoginQueryHandler() {
  const location = useLocation();
  const navigate = useNavigate();
  const { openLoginModal, loading, isLoggedIn, userTier } = useApp();

  useEffect(() => {
    if (loading) return;

    const params = new URLSearchParams(location.search);
    const auth = params.get('auth');
    if (auth !== 'login' && auth !== 'signup') return;

    const returnTo = sanitizeReturnTo(params.get('return_to'));

    const cleanUrl = () => {
      params.delete('auth');
      params.delete('return_to');
      const qs = params.toString();
      navigate({ pathname: location.pathname, search: qs ? `?${qs}` : '' }, { replace: true });
      removeStoredQueryParams('auth', 'return_to');
    };

    if (isLoggedIn && userTier !== 'guest') {
      followLoginReturnUrl(returnTo, navigate);
      cleanUrl();
      return;
    }

    openLoginModal(undefined, returnTo ?? undefined, auth === 'signup' ? 'signup' : 'signin');
    cleanUrl();
  }, [isLoggedIn, loading, location.pathname, location.search, navigate, openLoginModal, userTier]);

  return null;
}
